import { useEffect, useRef, useState, useCallback } from 'react';
import style from './FormNumber.module.scss';

const FormNumber = ({ defaultValue, onChange = () => {}, step = 1, min = 0, max, unit = '', typeable = false }) => {
  step = +step;
  min = +min;
  max = +max;

  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);
  const typingRef = useRef(null);
  const [value, setValue] = useState(defaultValue);

  const decreaseValue = useCallback(() => {
    setValue((prevValue) => {
      let newValue = prevValue - step;
      return newValue < min ? min : newValue;
    });
  }, [step, min]);

  const increaseValue = useCallback(() => {
    setValue((prevValue) => {
      let newValue = prevValue + step;
      return newValue > max ? max : newValue;
    });
  }, [step, max]);

  const mouseDownHandler = (action) => {
    action();
    timeoutRef.current = setTimeout(() => {
      intervalRef.current = setInterval(action, 50);
    }, 300);
  };

  const mouseUpHandler = () => {
    clearInterval(intervalRef.current);
    clearTimeout(timeoutRef.current);
  };

  const onChangeHandler = (e) => {
    clearTimeout(typingRef.current);

    const value = parseInt(e.target.value);

    setValue(value);

    typingRef.current = setTimeout(() => {
      if (value > max) {
        setValue(max);
      } else if (value < min) {
        setValue(min);
      } else if (isNaN(value)) {
        setValue(0);
      }
    }, 1000);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, 500);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [value]);

  return (
    <div className={style.number}>
      <button
        className={style.number_btn}
        type="button"
        onMouseDown={() => mouseDownHandler(decreaseValue)}
        onMouseUp={mouseUpHandler}
        onMouseLeave={mouseUpHandler}
      >
        <i className="material-symbols-outlined">remove</i>
      </button>
      {typeable ? <input type="text" value={value} onChange={onChangeHandler} /> : <span>{value}</span>}
      <span className={style.number_unit}>{unit}</span>
      <button
        className={style.number_btn}
        type="button"
        onMouseDown={() => mouseDownHandler(increaseValue)}
        onMouseUp={mouseUpHandler}
        onMouseLeave={mouseUpHandler}
      >
        <i className="material-symbols-outlined">add</i>
      </button>
    </div>
  );
};

export default FormNumber;
